module.exports = "https://r.zoocdn.com/_next/static/images/buying-chapter-hero-4aeba0edcc911c667822697571ddbd6b.svg";